import RestAdapter from "discourse/adapters/rest";
export default RestAdapter.extend({
  cache: true
});